import { getGenericStore } from './genericStore';

const selectedConstructionInfoStore = Object.create(getGenericStore());
export default selectedConstructionInfoStore;